export default __webpack_public_path__ + "static/media/Vector.205faa66.svg";